import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';

export const LazyJiraMacroRepairPage: LoadableType<{}> = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-JiraMacroRepairContainer" */ '../src/JiraMacroRepair/JiraMacroRepairPage.tsx'
			)
		).JiraMacroRepairPage,
});
